module.exports = __webpack_public_path__ + "bb.svg?0dca8c8f07eeeedf76c5bcce4d949082";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/bb.svg
// module id = 944
// module chunks = 27